import { upsellingModal } from '@/shared/components/UpsellingModal';

import { type PlanFeatureType } from './consts';
import { useUserPlanManager } from './UserPlanManagerProvider';

export const useUpsellingGuard = () => {
  const { userPlanManager } = useUserPlanManager();

  return <T>(
    action: () => T,
    options: {
      feature: PlanFeatureType;
      from: string;
      moreConditionForGuard?: boolean;
      onGuard?: () => void;
    },
  ): T | void => {
    const canAccessFeature = userPlanManager.canAccessFeature(options.feature);
    const shouldGuard =
      !canAccessFeature && (options.moreConditionForGuard ?? true);
    if (shouldGuard) {
      if (options.onGuard) {
        options.onGuard();
        return;
      }
      const featurePlanType = userPlanManager.getFeaturePlanType(
        options.feature,
      );
      upsellingModal.open({
        initialPlanType: featurePlanType,
        from: options.from,
      });
      return;
    }
    return action();
  };
};
